import React, { useEffect } from 'react';
import { string, bool } from 'prop-types';
import useMobileWebview from '../../hooks/useMobileWebview';
import { heapTrackEvent } from '../baui-heap-tracking';

// TODO standardize styling. use ui-spinner?
const Spinner = props => {
  useMobileWebview();

  useEffect(() => {
    heapTrackEvent('PL Spinner', { ShowSpinner: props.show }); // TODO only track on props.show? else this will track upon initial load as well (with false value)
  }, [props.show]);

  return (
    props.show && (
      <div className="rc-spinner">
        <div className="rc-spinner__header">{props.header}</div>
        <div className="rc-spinner__text">{props.text}</div>
        <div className="rc-spinner__icon" />
      </div>
    )
  );
};

Spinner.propTypes = {
  header: string.isRequired,
  text: string,
  show: bool,
};

Spinner.defaultProps = {
  text: '',
  show: false,
};

export default Spinner;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-spinner/rc-spinner.scss');